import { IDEAL_ASPECT_RATIO_PERCENTAGE } from '@bingads-webui-campaign-react/smart-component-util';

export const getStyles = () => ({
  imageCropperPreview: {
    position: 'absolute',
    width: '100%',
    paddingTop: `${IDEAL_ASPECT_RATIO_PERCENTAGE}%`,
    overflow: 'hidden',
  },
  imageCropperEditor: {
  },
  // #region Preview styles
  overlayPreview: {
    position: 'absolute',
    top: 0,
    width: '100%',
    height: '100%',
  },
  preview: {
    width: '100%',
    height: '100%',
  },
  previewLoading: {
    position: 'absolute',
    top: 0,
    zIndex: 1,
  },
  img: {
    width: '100%',
    height: 'auto',
  },
  // #endregion
  // #region Editor styles
  unclickable: {
    pointerEvents: 'none',
  },
  overlay: {
    position: 'absolute',
    width: '100%',
    paddingTop: `${IDEAL_ASPECT_RATIO_PERCENTAGE}%`,
    marginTop: '100px',
  },
  overlayStrip: {
    position: 'absolute',
    width: 5,
    height: 5,
    background: 'black',
  },
  overlayMessage: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translateY(-50%) translateX(-50%)',
    height: 40,
    borderRadius: 20,
    background: 'rgba(0, 0, 0, 0.9)',
    color: '#ffffff',
    border: 'none',
    padding: '0px 16px',
    minWidth: 80,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& .ms-Icon': {
      margin: '0px 4px',
      textAlign: 'center',
      fontSize: '16px',
      lineHeight: '16px',
    },
    '& span': {
      margin: '0px 4px',
      lineHeight: '100%',
      display: 'block',
      fontWeight: '600',
    },
  },
  verticalStrip: {
    height: 20,
  },
  horizontalStrip: {
    width: 20,
  },
  topStrip: {
    top: 0,
  },
  middleStrip: {
    top: 'calc(50% - 10px)',
  },
  bottomStrip: {
    bottom: 0,
  },
  leftStrip: {
    left: 0,
  },
  rightStrip: {
    right: 0,
  },
  // #endregion
});
